import Divisi from "./Divisi";
import BaseModel from "./_BaseModel";

export default class Gudang extends BaseModel {
    public readonly ucode?: string;
    public kode?: string;
    public nama?: string;
	public alamat?: string;
	public keterangan?: string;
    public aktif?: boolean = true;
	public ucode_divisi?: string;
    public divisi?: Divisi;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}